var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.fullscreenLoading,
          expression: "fullscreenLoading",
          modifiers: { fullscreen: true, lock: true }
        }
      ],
      staticClass: "edit-picker-box"
    },
    [
      _c(
        "el-dialog",
        { attrs: { title: "", visible: true, "before-close": _vm.closeBox } },
        [
          _vm.id == 0
            ? _c(
                "div",
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.form, "label-width": "80px" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "买手组:" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "50%" },
                            attrs: { placeholder: "买手组" },
                            model: {
                              value: _vm.form.pg_name,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "pg_name", $$v)
                              },
                              expression: "form.pg_name"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "组长:" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "50%" },
                              attrs: { filterable: "", placeholder: "组长" },
                              model: {
                                value: _vm.form.group_leader,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "group_leader", $$v)
                                },
                                expression: "form.group_leader"
                              }
                            },
                            _vm._l(_vm.group_leader, function(item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "代号:" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "50%" },
                            attrs: { placeholder: "代号" },
                            model: {
                              value: _vm.form.pg_code,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "pg_code", $$v)
                              },
                              expression: "form.pg_code"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "市场:" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "50%" },
                              attrs: { filterable: "", placeholder: "市场" },
                              model: {
                                value: _vm.form.market_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "market_id", $$v)
                                },
                                expression: "form.market_id"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { value: "", label: "全部" }
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.market, function(item) {
                                return _c("el-option", {
                                  key: item.market_id,
                                  attrs: {
                                    value: item.market_id,
                                    label: item.market_name
                                  }
                                })
                              })
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "状态:" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "50%" },
                              attrs: { placeholder: "状态" },
                              model: {
                                value: _vm.form.status,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "status", $$v)
                                },
                                expression: "form.status"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { value: "", label: "全部" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: "1", label: "启用" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: "0", label: "禁用" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "25%" },
                              on: { click: _vm.closeBox }
                            },
                            [_vm._v("取消")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "25%" },
                              attrs: { type: "success" },
                              on: { click: _vm.submitData }
                            },
                            [_vm._v("确认")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.id > 0
            ? _c(
                "div",
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.form, "label-width": "80px" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "买手组:" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "50%" },
                            attrs: { disabled: "", placeholder: "买手组" },
                            model: {
                              value: _vm.form.pg_name,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "pg_name", $$v)
                              },
                              expression: "form.pg_name"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "组长:" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "50%" },
                              attrs: { filterable: "", placeholder: "组长" },
                              model: {
                                value: _vm.form.group_leader,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "group_leader", $$v)
                                },
                                expression: "form.group_leader"
                              }
                            },
                            _vm._l(_vm.group_leader, function(item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "代号:" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "50%" },
                            attrs: { placeholder: "代号", disabled: "" },
                            model: {
                              value: _vm.form.pg_code,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "pg_code", $$v)
                              },
                              expression: "form.pg_code"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "市场" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "50%" },
                              attrs: { filterable: "", placeholder: "市场" },
                              model: {
                                value: _vm.form.market_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "market_id", $$v)
                                },
                                expression: "form.market_id"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { value: "", label: "全部" }
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.market, function(item) {
                                return _c("el-option", {
                                  key: item.market_id,
                                  attrs: {
                                    value: item.market_id,
                                    label: item.market_name
                                  }
                                })
                              })
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "状态:" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "50%" },
                              attrs: { placeholder: "状态" },
                              model: {
                                value: _vm.form.status,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "status", $$v)
                                },
                                expression: "form.status"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { value: "", label: "全部" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: "1", label: "启用" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: "0", label: "禁用" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "25%" },
                              on: { click: _vm.closeBox }
                            },
                            [_vm._v("取消")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "25%" },
                              attrs: { type: "success" },
                              on: { click: _vm.savesSubmitData }
                            },
                            [_vm._v("确认")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4481ffb4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4481ffb4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/picker/components/EditPicker.vue
// module id = null
// module chunks = 